module.exports = __webpack_public_path__ + "img/african_union.e1d8d2fd.png";